import { InfoCircleOutlined, WarningOutlined } from "@/icons"

import styles from "./PriorityIcon.module.scss"

import type { Priority } from "@/domain/adr"

export const PriorityIcon = ({ priority }: { priority: Priority }) => {
  if (priority === "warning") return <WarningOutlined className={styles.icon} />

  return <InfoCircleOutlined className={styles.icon} />
}
